import { useRedlines } from "@/hooks/use-redlines";
import { DocumentClassification } from "@/types/risk-analysis";
import React, { createContext, ReactNode, useContext } from "react";

const RedlinesContext = createContext<ReturnType<typeof useRedlines>>(undefined);

interface RedlinesProviderProps {
  classification: DocumentClassification;
  selectedRule: DocumentClassification["rules"][number];
  children: ReactNode;
}

export const RedlinesProvider: React.FC<RedlinesProviderProps> = ({ classification, selectedRule, children }) => {
  const redlinesProps = useRedlines(classification, selectedRule);
  return <RedlinesContext.Provider value={redlinesProps}>{children}</RedlinesContext.Provider>;
};

export const useRedlinesContext = () => {
  const context = useContext(RedlinesContext);
  if (context === undefined) {
    throw new Error("useRedlinesContext must be used within an RedlinesProvider");
  }
  return context;
};
